import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/layouts/Layout'
import RequireAuth from './components/RequireAuth'
import Loader from './components/UI/Loader'
import { routes } from './constants/routes'
import useDocumentTitle from './hooks/useDocumentTitle'
import { useAppSelector } from './hooks/useAppSelector'
import { useGetCurrentUserQuery } from './store/admins/admins.api'
import AuthLayout from './components/layouts/AuthLayout'

const SignIn = lazy(() => import('./pages/SignIn'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const ChangePassword = lazy(() => import('./pages/ChangePassword'))

function App() {
	useDocumentTitle()

	const { isAuth } = useAppSelector((state) => state.auth)
	const { data: user, isLoading } = useGetCurrentUserQuery({}, { skip: !isAuth })

	const filteredRoutes = user?.permissions?.length ? routes.filter((i) => user.permissions.includes(i.permissionKey)) : []

	return (
		<Routes>
			<Route path={'/'} element={<Layout />}>
				{filteredRoutes.length ? (
					filteredRoutes.map((route) => (
						<Route
							key={route.path}
							path={route.path}
							element={<Suspense fallback={<Loader />}>{route.isPrivate ? <RequireAuth>{route.element}</RequireAuth> : route.element}</Suspense>}
						/>
					))
				) : (
					<Route path="/" element={<Navigate to={'/sign-in'} replace />} />
				)}
			</Route>

			<Route path={'/'} element={<AuthLayout />}>
				<Route
					path={'/sign-in'}
					element={
						<Suspense fallback={<Loader />}>
							<SignIn />
						</Suspense>
					}
				/>
				<Route
					path={'/forgot-password'}
					element={
						<Suspense fallback={<Loader />}>
							<ForgotPassword />
						</Suspense>
					}
				/>
				<Route
					path={'/change-password'}
					element={
						<Suspense fallback={<Loader />}>
							<ChangePassword />
						</Suspense>
					}
				/>
			</Route>

			<Route path="*" element={isLoading ? <Layout /> : <Navigate to={'/'} replace />} />
		</Routes>
	)
}

export default App
